import React, { Component } from "react";

class Kurser extends Component {
  render() {
    return (

<center>
  <div className="info" style={{ textAlign: "left" }}>
    <center>
      <h1>
        Kurser på folkmusikkaféet
        <br />
        Våren 2026
      </h1>
    </center>
    <br />

    {/* Spelmanslaget */}
    <center>
      <h3>Spelmanslaget</h3>
      <img
        className="kursbild-mindre fade-in-fast"
        style={{ paddingRight: "40px" }}
        src="img/arkiv/jon_olov.jpg"
        alt="Jon-Olov Woxlin"
      />
      <img
        className="kursbild-mindre fade-in-fast"
        src="img/arkiv/dan_palmqvist_small.jpg"
        alt="Dan Palmqvist"
      />
    </center>
    <center>
      <div className="kompakt">
        Kursen hålls fredagar kl 17:30 – 19:15 med start 23 januari och omfattar hela våren och
        alla med akustiska instrument är välkomna. Vi ser gärna att du har något eller några års
        erfarenhet på ditt instrument. Som kompmusiker ser vi helst att du är relativt självständig
        och kan lite grunder i folkmusik.
        <br />
        <br />
        Kursinstruktör: Jon-Olov Woxlin och Dan Palmqvist.
        <br />
        <br />
        Kostnad: 600 kr (ung &amp; stud 350 kr) betalas in på pg 107741–1 eller Swish 1236085450.
        Ange namn + ”spelmanslaget”.
        <br />
        <br />
        <small>
          Information: Dan Palmqvist,{" "}
          <a href="mailto:dan.palmqst@gmail.com">dan.palmqst@gmail.com</a>
        </small>
      </div>
    </center>
    <br />

    {/* Nybörjarkurs i dans */}
    <center>
      <h3>Nybörjarkurs i dans till folkmusik</h3>
    </center>
    <br />
    <center>
      <img
        style={{ width: "40%", borderRadius: "10px" }}
        src="img/program/vt2026/danskurs.jpg"
        alt="Nybörjarkurs i dans"
      />
    </center>
    <br />
    <center>
      <small>Sex fredagskvällar med start 30/1 och avslutning 6/3.</small>
      <br />
      <br />
      <div className="kompakt">
        Kursen ger grunderna i de vanligast förekommande danserna på Folkmusikkaféet och andra
        liknande folkmusik- och dansställen i Sverige. Vi tar i första hand upp pardanserna
        schottis, polska, slängpolska och vals samt gruppdansen engelska – men även andra inslag
        kan förekomma.
        <br />
        <br />
        Kursinstruktörer: Mats Nilsson och Ingegerd Sigfridsson.
        <br />
        Spelman: Staffan Folestad
        <br />
        <br />
        Tider: Fredagskvällar 18:00 – 19:30.
        <br />
        Kursavgift: 600 kr (ung &amp; stud 300 kr).
        <br />
        <br />
        Kursen arrangeras i samarbete med Bilda. <br />
        <b>Länk till anmälan:</b>{" "}
        <a href="https://www.bilda.nu/arr/1277053/nyborjarkurs-i-dans-till-folkmusik-folkmusikkafeet-allegarden-929002">
          Klicka här
        </a>
        .
        <br />
        <br />
        Frågor till Mats Nilsson, tel. 070-5577916 eller{" "}
        <a href="mailto:kurser@folkmusikkafeet.net">kurser@folkmusikkafeet.net</a>
      </div>
    </center>
    <br />

    {/* Låtkurs med Kjell-Erik Eriksson */}
    <center>
      <h3>Låtkurs med Kjell-Erik Eriksson</h3>
    </center>
    <center>
      <img
        style={{ width: "40%", borderRadius: "10px" }}
        src="img/program/vt2026/kjell_erik.jpg"
        alt="Kjell-Erik Eriksson"
      />
    </center>
    <br />
    <center>
      <div className="kompakt">
        Det är Jämtlåtarna som står i fokus då Kjell-Erik kommer och håller kurs i Göteborg den 21
        mars. Under kursen blir det förutom låtutlärning, fokus på sväng, samspel, stämspel, komp
        och en och annan historia.
        <br />
        <br />
        Kjell-Erik har jobbat som spelman i över 30 år. Sitt intresse för folkmusiken och fiolmusiken
        startade i tidigt tonår hemma i Offerdal. Lapp-Nilslåtarna och historierna runt spelmännen
        lockade och han började gräva i arkiven och besöka spelmän.
        <br />
        <br />
        Kjell-Erik har sedan början av 1990-talet spelat med i folkrockgruppen Hoven Droven och
        vistrion Triakel, spelar numera även med i grupperna Breda gatan och Bo Lyckligs
        gammeldansorkester.
        <br />
        <br />
        Kjell-Erik jobbar som lärare på Birka folkhögskolas folkmusiklinje och hoppar ofta och gärna
        in som gästlärare på andra skolor och kurser.
        <br />
        <br />
        Som kursdeltagare behöver du behärska ditt instrument någorlunda.
        <br />
        <br />
        Kursledare: Kjell-Erik Eriksson
        <br />
        Tid: Lördag 21/3 kl 10:00 – 16:00
        <br />
        Plats: Gräfsnäsgården
        <br />
        Kursavgift: 450 kr (ung &amp; stud 250 kr).
        <br />
        <br />
        Kursen arrangeras i samarbete med Bilda. Kursanmälan görs senast 6/3, <b>länk till anmälan:</b>{" "}
        <a href="https://www.bilda.nu/arr/1279262/latkurs-med-kjell-erik-eriksson-929325">Klicka här</a>
        <br />
        <br />
        Frågor:{" "}
        <a href="mailto:kurser@folkmusikkafeet.net">kurser@folkmusikkafeet.net</a>, tel. 0703327781
        (Lars-Gunnar Franzén)
      </div>
    </center>
    <br />

    {/* Viskurs med Emma Härdelin */}
    <center>
      <h3>Viskurs med Emma Härdelin</h3>
    </center>
    <center>
      <img
        style={{ width: "40%", borderRadius: "10px" }}
        src="img/program/vt2026/emma_hardelin.jpg"
        alt="Emma Härdelin"
      />
    </center>
    <br />
    <center>
      <div className="kompakt">
        Vill du utöka din repertoar av folkliga visor med några gobitar ur Emma Härdelins
        musikskafferi? Då är det här rätt tillfälle! Möt Emma och lär dig några av hennes favoriter
        med teman från vallvisor, kärlek och skämtvisor. Vi sjunger tillsammans på gehör.
        <br />
        <br />
        Emma Härdelin är svensk vissångerska i grupperna Triakel, Garmarna och Breda gatan.
        <br />
        <br />
        Kursledare: Emma Härdelin
        <br />
        Tid: Lördag 21/3 kl 10:00 – 16:00
        <br />
        Plats: Gräfsnäsgårdens annex
        <br />
        Kursavgift: 450 kr (ung &amp; stud 250 kr).
        <br />
        <br />
        Kursen arrangeras i samarbete med Bilda. Kursanmälan görs senast 6/3, <b>länk till anmälan:</b>{" "}
        <a href="https://www.bilda.nu/arr/1279370/viskurs-med-emma-hardelin-929355">Klicka här</a>
        <br />
        <br />
        Frågor:{" "}
        <a href="mailto:kurser@folkmusikkafeet.net">kurser@folkmusikkafeet.net</a>, tel. 0703327781
        (Lars-Gunnar Franzén)
      </div>
    </center>
    <br />

    {/* Danskurs med Agnes & Klara */}
    <center>
      <h3>Danskurs i improvisation och samspel med Agnes &amp; Klara</h3>
    </center>
    <center>
      <img
        style={{ width: "40%", borderRadius: "10px" }}
        src="img/program/vt2026/agnes_klara.jpg"
        alt="Agnes & Klara"
      />
    </center>
    <br />
    <center>
      <div className="kompakt">
        Välkommen på danskurs med Agnes &amp; Klara där vi tillsammans kommer att utforska dansen och
        samspelet med musiken. Musiker på kursen kommer att vara Lovis Jacobsson (cittern). Ett
        särskilt fokus kommer läggas på musikalitet och improvisation. Vi delar med oss av våra knep
        och tips om hur vi spelar musiken med våra danskroppar. Under kursen jobbar vi utifrån olika
        musikaliska sväng såsom triolpolska och slängpolska.
        <br />
        <br />
        Nivån för kursen är blandad men det är en fördel om man har dansat lite innan. Vi välkomnar
        även rutinerade dansare då det bland annat kommer att finnas möjlighet till att fördjupa sin
        egen dans och prova på både förar/följarrollen. Kursen kommer att ha ett lugnt tempo med tid
        för frågor. Du behöver inte ha med en danspartner till kursen men får gärna ta med alla du
        tror är intresserade av att också gå på kurs.
        <br />
        <br />
        Kursledare: Agnes Rodhe och Klara Andersson. Musiker: Lovis Jacobsson
        <br />
        Tid: Lördag 18/4 kl 10:00 – 16:00
        <br />
        Plats: Gräfsnäsgården
        <br />
        Kursavgift: 500 kr (ung &amp; stud 300 kr).
        <br />
        <br />
        Kursen arrangeras i samarbete med Bilda. Kursanmälan görs senast 17/3, <b>länk till anmälan:</b>{" "}
        <a href="https://www.bilda.nu/arr/1279309/danskurs-i-improvisation-och-samspel-till-folkmusik-929335">
          Klicka här
        </a>
        <br />
        <br />
        Frågor:{" "}
        <a href="mailto:kurser@folkmusikkafeet.net">kurser@folkmusikkafeet.net</a>
        <br />
        <br />
        <i>
          Kursdeltagare får 50 % rabatt på konsertkvällar under kursen (detta kan ej kombineras med
          andra rabatter).
        </i>
      </div>
    </center>
    <br />

    {/* Tillsammansgruppen */}
    <center>
      <h3>Tillsammansgruppen</h3>
      <img className="kursbild fade-in-fast" src="img/tillsammansgruppen.jpg" alt="Tillsammansgruppen" />
    </center>
    <center>
      <div className="kompakt">
        Genom alla tider har vi lekt på fest och till vardags, barn som vuxen. Tillsammansgruppen
        ger dig möjlighet att ta del av denna roliga tradition.
        <br />
        Stora som små är varmt välkomna att hänga med i vindlande långdanser och visor.
        <br />
        Det är motion för både kropp som knopp!
        <br />
        <br />
        Tider: 18:00 – 19:30 med tid för fika.
        <br />
        Datum: 23/1, 20/2 och 20/3
        <br />
        Instruktörer: Gunnel Sjögren och Gunilla Sellersjö
        <br />
        <br />
        Kostnad: Gratis för barn i sällskap med någon vuxen.
      </div>
    </center>
    <br />
    <br />

    <center>
      <small><i>Folkmusikkaféet samarbetar med och stöds av:</i></small>
      <br />
    </center>
  </div>
</center>
    );
  }
}

export default Kurser;
